import { injectable } from "inversify";
import { IAddressLookupService } from "../interfaces/addressLookupService";
import { ServiceResponse, AddressSearchResultsDto, AddressDto } from "../../platform/models";
import { ServiceResponseErrorCode } from "../../platform/enums";


@injectable()
class AddressLookupService implements IAddressLookupService {

    public async searchAddresses(searchTerm: string, antiForgeryToken: string): Promise<ServiceResponse<AddressSearchResultsDto>> {
        try {
            const baseUrl = window.location.origin;
            const endpoint = '/api/lookups/addresses/search-results';

            const response = await fetch(`${baseUrl}${endpoint}?partial=${encodeURIComponent(searchTerm)}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'RequestVerificationToken': antiForgeryToken
                },
            });

            if (!response.ok) {
                return new ServiceResponse<AddressSearchResultsDto>(
                    ServiceResponseErrorCode.SystemError,
                    `HTTP ${response.status}: ${response.statusText}`
                );
            }

            const data = await response.json();
            return new ServiceResponse<AddressSearchResultsDto>(data);

        } catch (error) {
            return new ServiceResponse<AddressSearchResultsDto>(
                ServiceResponseErrorCode.SystemError,
                error.message
            );
        }
    }

    public async getAddress(addressId: string, antiForgeryToken: string): Promise<ServiceResponse<AddressDto>> {
        try {
            const baseUrl = window.location.origin;
            const endpoint = '/api/lookups/addresses';

            const response = await fetch(`${baseUrl}${endpoint}?addressId=${encodeURIComponent(addressId)}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'RequestVerificationToken': antiForgeryToken
                },
            });

            if (!response.ok) {
                return new ServiceResponse<AddressDto>(
                    ServiceResponseErrorCode.SystemError,
                    `HTTP ${response.status}: ${response.statusText}`
                );
            }

            const data = await response.json();
            return new ServiceResponse<AddressDto>(data);

        } catch (error) {
            return new ServiceResponse<AddressDto>(
                ServiceResponseErrorCode.SystemError,
                error.message
            );
        }
    }
};

export { AddressLookupService }